// extracted by mini-css-extract-plugin
module.exports = {"catalogListSection":"CatalogListGrid_catalogListSection__SiH8K","catalogListContainer":"CatalogListGrid_catalogListContainer__rvd2j"};